@if(this.signals.faceCapture.status() == 'failed'){
<!-- <div class="alert alert-danger text-tertiary-dark fs-9">
  {{ `app.pageId.biometric.messages.${this.signals.faceCapture.statusMotive()?.key}` | translate: this.signals.faceCapture.statusMotive()?.params }}
</div> -->
<div class="alert alert-danger text-tertiary-dark fs-9">
  {{ this.signals.faceCapture.statusMotive()?.key }}
</div>
} @if(this.signals.faceCapture.status() == 'invalid'){
<div class="alert alert-danger text-tertiary-dark fs-9">
  {{ this.signals.faceCapture.statusMotive()?.key }}
</div>
}

<div
  class="d-flex flex-row justify-content-center capture-face-container"
  [class]="signals.faceCapture.status() != 'validated' ? 'd-flex' : 'd-none'"
>
  <div class="capture-area d-flex flex-column gap-2">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div
        [class]="show() ? 'd-flex' : 'd-none'"
        id="vu.sop"
        class="shadow-sm d-flex align-items-center justify-content-center"
      ></div>

      <div
        [class]="!show() ? 'd-flex' : 'd-none'"
        class="shadow-sm align-items-center justify-content-center vu-placeholder"
      >
        <icon
          [class]="this.signals.faceCapture.values().length > 0 ? 'd-none' : ''"
          [icon]="icons.camera"
          color="info-light"
          size="75"
        />
        <div
          [class]="
            signals.faceCapture.status() == 'validating' ? 'd-flex' : 'd-none'
          "
        >
          <icon [icon]="icons.spinner" size="150" color="primary" />
        </div>
        <div
          [class]="
            signals.faceCapture.status() == 'invalid' ? 'd-flex' : 'd-none'
          "
        >
          <icon [icon]="icons.x" size="125" color="tertiary" />
        </div>
      </div>
      <vu-audio-es />
    </div>
  </div>

  <div class="divider-vertical"></div>

  <div class="capture-options d-flex flex-column justify-content-center">
    <span class="fw-medium pb-2 text-center d-flex flex-column align-items-center">
      @if(selectedCompanion()){
      {{
        "app.pageId.biometric.capture-face.indication-companion"
          | translate
      }}
      } @else {
      {{
        "app.pageId.biometric.capture-face.indication-patient"
          | translate
      }}
      }
      <button-component [config]="btns().biometricIndications" />
    </span>

    <div class="pt-3 d-flex flex-column gap-1">
      <button-component [config]="btns().validateCapture" />
      <button-component [config]="btns().capture" />
      <button-component [config]="btns().retryCapture" />
    </div>
  </div>
</div>

<div
  class="flex-column gap-4 align-items-center justify-content-center"
  [class]="signals.faceCapture.status() == 'validated' ? 'd-flex' : 'd-none'"
  style="width: 70%; margin: auto"
>
  <span
    class="fs-4 text-center text-success fw-semibold"
    style="line-height: 2rem"
    >{{ "app.pageId.biometric.messages.success" | translate }}</span
  >
  <div
    class="bg-primary-light p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
    style="width: 325px; height: 325px"
  >
    <div
      class="bg-primary p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
      style="width: 275px; height: 275px"
    >
      <div
        class="bg-primary-dark p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
        style="width: 225px; height: 225px"
      >
        <icon [icon]="icons.check" size="150" color="primary-light" />
      </div>
    </div>
  </div>
</div>

<ng-template #tpl>
  <!-- <div class="unsupported">
        {{
          isFirefox
            ? 'Cámara no soportada'
            : 'Debe permitir el uso de la cámara para continuar con la validación'
        }}
      </div> -->
</ng-template>
